import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Box, Stack, Typography } from '@mui/material'

import { isUserAuthenticated } from '@/features/domain/user'
import { useNavigate } from '@/routing'

import { ErrorTooManySessionsImage } from './ErrorTooManySessionsImage'
import { useTexts } from './useTexts'

export function TooManySessions() {
  const authenticated = useSelector(isUserAuthenticated)
  const navigate = useNavigate(true)
  const texts = useTexts()

  // Redirects the user to the home if is authenticated
  useEffect(() => {
    if (authenticated) {
      navigate('/')
    }
  }, [navigate, authenticated])

  return (
    <Stack direction="column" spacing={3} textAlign="center" alignItems="center">
      <Box>
        <ErrorTooManySessionsImage />
      </Box>
      <Stack direction="column" spacing={1}>
        <Typography variant="h6">{texts.tooManyOpenTabsTitle}</Typography>
        <Typography variant="body2">{texts.tooManyOpenTabsSubtitle}</Typography>
      </Stack>
    </Stack>
  )
}
